/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'button');
      this.tabIndex = 0;
      this.abortController = new AbortController();
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.click();
        }
      }, { signal: this.abortController.signal });
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('cart:remove', {
          bubbles: true,
          detail: { index: this.dataset.index }
        }));
      }, { signal: this.abortController.signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  }
  customElements.define('cart-remove', CartRemove);
}